import taskService from 'resources/task/task.service';
import { uploadDocumentsToTask } from 'resources/document/workflows';


export const updateTaskWithDocument = async ({
  taskId,
  taskCompanyId,
  dataToUpdate,
  fileData, // nullable
}) => {
  const updatedTask = await taskService.updateTask({
    id: taskId,
    ...dataToUpdate,
  });

  await uploadDocumentsToTask({
    fileData,
    taskId,
    taskCompanyId,
  });

  return updatedTask;
};
